'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (category) {
    return {
        callput: 'Up/Down',
        risefall: 'Rise/Fall',
        higherlower: 'Higher/Lower',
        asian: 'Asians',
        digits: 'Digits',
        endsinout: 'Ends In/Out',
        staysinout: 'Stays In/Out',
        touchnotouch: 'Touch/No Touch',
        spreads: 'Spreads'
    }[category];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/trade/contractCategoryToText.js
// module id = 610
// module chunks = 0